import React from 'react';
import { Link } from 'react-router-dom';
import routes from '../../../../utils/commonVariables/routes';
import Icon from '../../../../muiComponents/Icon';
import useTranslate from '../../../../customHooks/useTranslate';

const IncomingRequestsAlert = () => {
    const translate = useTranslate();
    return (
        <div className='flex gap-20'>
            <div className='flex gap-10'>
                <Icon iconName='Info' />
                <p className='font-weight-600 text-secondary-700'>
                    {translate('you_have_pending_incoming_requests')}
                </p>
            </div>
            <Link
                to={
                    routes.landingPrivate +
                    routes.zinantisSection +
                    routes.zinantisConnectionRequests
                }
                className='flex gap-5 flex-align-center font-weight-600'
            >
                <Icon iconName='Cable' />
                {translate('go_to_requests')}
            </Link>
        </div>
    );
};

export default IncomingRequestsAlert;
